import { SpineView, SpineViewOpts } from '@play-co/timestep-spine';
import NakedPromise from 'src/game/minigame/match2-timestep/lib/pattern/NakedPromise';

type CompleteHandler = (interrupt?: boolean) => void;
type EventHandler = (id?: string) => void;

export default class SpineAnimationView extends SpineView {
  protected _onComplete?: CompleteHandler;
  protected _onEvent?: EventHandler;

  constructor(opts: SpineViewOpts) {
    super(opts);

    // Register events
    this.state.addListener({
      interrupt: (entry) => this._onComplete?.(true),
      complete: (entry) => this._onComplete?.(),
      event: (entry, event) => this._onEvent?.(event.data.name),
    });
  }

  public start({
    id,
    mix = 0.2,
    loop = false,
    speed = 1,
    offset = 0,
    onEvent,
  }: {
    id: string;
    mix?: number;
    loop?: boolean;
    speed?: number;
    offset?: number;
    onEvent?: EventHandler;
  }): {
    complete: Promise<boolean>;
    duration: number;
  } {
    const { state } = this;

    // Set animation state
    state.data.defaultMix = mix;
    state.timeScale = speed;

    // Set event handler
    this._onEvent = onEvent;

    try {
      // Update active animation
      const track = state.setAnimation(0, id, loop);

      // Register completion and wait - Note: this is to be instantiated after the setAnimation call to prevent premature promise resolution
      const complete = new NakedPromise<boolean>(
        (resolve) => (this._onComplete = resolve as CompleteHandler),
      );

      // Apply elapsed time offset, if provided
      if (offset) {
        track.trackTime = offset;
      }

      return {
        complete,
        duration: track.animation!.duration,
      };
    } catch {
      // Register completion and wait
      const complete = new NakedPromise<boolean>(
        (resolve) => (this._onComplete = resolve as CompleteHandler),
      );

      complete.resolve(true);

      return {
        complete,
        duration: 0,
      };
    }
  }
}
